/* esm.sh - mdast-util-gfm-autolink-literal@2.0.1 */
export * from "/*mdast-util-gfm-autolink-literal@2.0.1/esnext/mdast-util-gfm-autolink-literal.mjs";
